import { useContext } from 'react';
import ContactTagsContext from '../context/contactTagsContext';

const useContactTags = () => {
  const context = useContext(ContactTagsContext);
  return context;
};

export default useContactTags;
